'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagAdAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.95477e-05 0H28C27.9997 6.66667 28 13.3333 28 20C18.6666 20 9.33329 20 -4.57764e-05 20C-4.57764e-05 13.3333 -8.59215e-05 6.66667 -3.95477e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.95477e-05 0H28L28 20H-4.57764e-05L-3.95477e-05 0Z",
          fill: "#1537D1"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M18.6666 0H28L28 20H18.6666V0Z", fill: "#EA3058" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33329 20H18.6666V0H9.33329V20Z",
          fill: "#FFCF3C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6666 8.66667H14V9.33333H12.6666V8.66667Z",
          fill: "#FFEDB1"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.2754 8.66667H12.7245L12.8958 10.722C12.9246 11.0676 13.2134 11.3333 13.5601 11.3333H14.4398C14.7865 11.3333 15.0753 11.0676 15.1041 10.722L15.2754 8.66667ZM12.7245 8C12.3345 8 12.0277 8.33335 12.0601 8.72203L12.2314 10.7774C12.289 11.4685 12.8667 12 13.5601 12H14.4398C15.1332 12 15.7109 11.4684 15.7685 10.7774L15.9398 8.72203C15.9722 8.33335 15.6654 8 15.2754 8H12.7245Z",
          fill: "#D32E28"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6666 9.33333L15.3333 9.33333V10H12.6666V9.33333Z",
          fill: "#D32E28"
        }
      )
    ]
  }
);
const VpFlagAdAsset = forwardRef(FlagAdAsset);

export { VpFlagAdAsset as default };
